import { useMutation, useQuery } from '@tanstack/react-query';
import { Button, SettingsRow } from '@wundo/ui';
import { fetchSlackInstallation, startSlackInstall } from '@/lib/slackInstallation.ts';
import { m } from '@/paraglide/messages.js';

/*
 * The organisation's Slack workspace, not this person's: one link for everyone
 * in it, which is why only admins see this row. There is no disconnect here —
 * removing the app in Slack itself unlinks it.
 */
export function SlackConnectionRow() {
  const { data, isPending, isError } = useQuery({
    queryKey: ['slackInstallation'],
    queryFn: fetchSlackInstallation,
  });

  /* Stays pending until the browser leaves for Slack's consent screen. */
  const install = useMutation({ mutationFn: startSlackInstall });

  return (
    <SettingsRow label={m.connections_slack()}>
      <div className='flex flex-wrap items-center gap-2'>
        {install.isError && (
          <span role='status' className='text-sm text-danger'>
            {m.connections_action_failed()}
          </span>
        )}

        {data?.connected ? (
          <span className='text-sm text-ink-muted'>
            {m.connections_slack_connected({ workspace: data.team_name ?? '' })}
          </span>
        ) : (
          <Button
            size='sm'
            disabled={isPending || isError || install.isPending}
            onClick={() => install.mutate()}
          >
            {m.connections_connect()}
          </Button>
        )}
      </div>
    </SettingsRow>
  );
}
